import type { ICategory } from "app/common/services/categoryService.types";
import type { FC, MouseEventHandler } from "react";
import { FadeWrapper } from "app/pages/industry-analysis/home/StyledComponents";
import { translate } from "app/filters/i18nFilter";
import { SWReactIcons } from "@similarweb/icons";
import { PlainTooltip } from "@similarweb/ui-components";

interface ISharedCustomIndustryItem {
    industry: ICategory;
    onCloneClick: MouseEventHandler<HTMLDivElement>;
}

export const SharedCustomIndustryItem: FC<ISharedCustomIndustryItem> = (props) => {
    const { onCloneClick, industry } = props;
    const { categoryId } = industry;
    return (
        <FadeWrapper
            onClick={onCloneClick}
            key={`editIcon-${categoryId}`}
        >
            <PlainTooltip
                cssClass="plainTooltip-element"
                tooltipContent={translate("asset.sharing.clone.industry.tooltip")}
            >
                <div>
                    <SWReactIcons
                        iconName="duplicate-icon"
                        size="xs"
                    />
                </div>
            </PlainTooltip>
        </FadeWrapper>
    );
};
